// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1Ylzl","search":"Settings_search__25xon","filter":"Settings_filter__36NVL"};